app.service("TileService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const TileModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Tile",
        id: "tile",
        navigation_pointer: "tile_id"
    });

    this.factory = new modelConstructor.RouteFactory({
        birth: function (values) {
            return new TileModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const browseID = variationIDs.browse_id;
        const componentID = variationIDs.component_id;
        const solutionID = variationIDs.solution_id;
        const requestRangeID = variationIDs.request_range_id;
        const parentCategoryGroupID = variationIDs.parent_category_group_id;
        const siteRangeID = variationIDs.site_range_id;
        const styleID = variationIDs.style_id;
        const colourID = variationIDs.colour_id;
        const tabID = variationIDs.tab_id;

        const useComponentID = componentID !== "solution_extra" ? componentID : tabID;

        let choiceList = null
        let nextModelID;
        let choiceIsBreadcrumb = false;
        let previousChoiceIsBreadcrumb = false;
        if (browseID === "component") {
            nextModelID = "site_range";
            choiceIsBreadcrumb = true;
        } else {
            nextModelID = "individual_product";
            previousChoiceIsBreadcrumb = true;
        }

        if (useComponentID === "door") {
            const excludeChoiceOrder = browseID === "component" ? ["door_sloping", "door_sloping_calculator"] : null;
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("door", null, excludeChoiceOrder, parentCategoryGroupID, siteRangeID, colourID, styleID);
        } else if (useComponentID === "door_sloping") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("door", ["door_sloping", "door_sloping_calculator"], null, parentCategoryGroupID, siteRangeID, colourID, styleID);
        } else if (useComponentID === "frame") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("frame", null, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
        } else if (useComponentID === "panel_wrap") {
            const panelChoiceList = requestRangeID === "bella" ? $rootScope.service.cache_local_server.getParentCategoryChoiceList("panel", null, null, parentCategoryGroupID, siteRangeID, colourID, styleID) : [];
            const wrapChoiceList = requestRangeID !== "bella" || browseID !== "solution" || solutionID === "kitchen_inrail" ? $rootScope.service.cache_local_server.getParentCategoryChoiceList("wrap", null, null, parentCategoryGroupID, siteRangeID, colourID, styleID) : [];

            if (browseID === "solution") {
                choiceList = panelChoiceList.concat(wrapChoiceList);
            } else {
                choiceList = wrapChoiceList.concat(panelChoiceList);
            }
        } else if (useComponentID === "wrap") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("wrap", null, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
        } else if (useComponentID === "panel") {
            const panelChoiceOrder = solutionID === "kitchen_rigid_flat_pack" ? [
                "panel_edge_profiled",
                "panel_edge_square",
                "panel_tongue_and_groove"
            ] : null;
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("panel", panelChoiceOrder, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
        } else if (useComponentID === "component_accessory") {
            choiceList = $rootScope.service.cache_local_server.getAlphaCategoryChoiceList("stock", parentCategoryGroupID, "all_accessory", null, null, siteRangeID, colourID, styleID);
        } else if (useComponentID === "promotional") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryGroupChoiceList("stock", "promotional", null, null, siteRangeID, colourID, styleID);
            nextModelID = "select";
        }
        const choiceOrder = [];
        const choices = {};
        if (choiceList) {
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                choices[choice.id] = choice;
                choiceOrder.push(choice.id);
            }
        }
        model.choice_order = choiceOrder;
        model.choices = choices;
        model.next_model_id = nextModelID;
        model.choice_is_breadcrumb = choiceIsBreadcrumb;
        model.previous_choice_is_breadcrumb = previousChoiceIsBreadcrumb;

    }

}]);